
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageInfo } from './interfaces/sl-page-selector-interfaces';
import { SlButtonComponent } from '../sl-button/sl-button.component';

@Component({
  selector: 'sl-page-selector',
  standalone: true,
  imports: [SlButtonComponent],
  templateUrl: './sl-page-selector.component.html',
  styleUrl: './sl-page-selector.component.scss',
})
export class SlPageSelectorComponent {
  @Input() pageInfo!: PageInfo;
  @Output() pageChange = new EventEmitter<number>();

  changePage = (action: 'back' | 'next') => {
    if (
      (action === 'back' && !this.pageInfo.hasPrevious) ||
      (action === 'next' && !this.pageInfo.hasNext)
    )
      return;
    let newPageNumber = this.pageInfo.currentPage + 1;
    if (action === 'back') {
      newPageNumber = this.pageInfo.currentPage - 1;
    }
    const page = newPageNumber;
    this.pageChange.emit(page);
  };
}
